module.exports = __webpack_public_path__ + "static/media/skill-2.c2ff4453.svg";